import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { ModalService } from '@app/core/services/modal.service';
import { TranslateService } from '@app/core/services/translate.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2TableGet, P2TableService } from '@app/services/p2-table.service';

@Component({
    selector: 'tt-p2-table-edit',
    templateUrl: './p2-table-edit.component.html',
    styleUrls: ['./p2-table-edit.component.css'],
    standalone: false,
})
export class P2TableEditComponent implements OnInit, OnChanges {
    @Input() public p2TableKeyno?: string;

    @Input() public inline = false;

    @Output() public onSave = new EventEmitter<void>();

    public page?: P2TableGet;

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private p2Table: P2TableService,
        private translate: TranslateService,
        private modal: ModalService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            const response = await this.p2Table.saveTable(this.page);

            if (response.iserror !== '0') {
                const translations = await this.translate.translateBatch(['error', 'ok'] as const);

                await this.modal.show({
                    type: 'warning',
                    title: translations.error,
                    message: response.message,
                    buttons: [{
                        label: translations.ok,
                        cssClass: 'btn-warning',
                        close: true,
                        type: 'warning'
                    }]
                });

                return;
            }

            if (this.tabletSize.matches && this.inline) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        if (!this.p2TableKeyno) {
            const routeKeyno = this.navigator?.params['p2_table_keyno'];

            if (routeKeyno !== undefined && routeKeyno !== null) {
                this.p2TableKeyno = `${routeKeyno}`;
                void this.loadTable(this.p2TableKeyno);
            }
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['p2TableKeyno']?.currentValue !== undefined && changes['p2TableKeyno']?.currentValue !== null) {
            this.p2TableKeyno = `${changes['p2TableKeyno'].currentValue}`;
            void this.loadTable(this.p2TableKeyno);
        }
    }

    private async loadTable(keyno: string): Promise<void> {
        this.page = await this.p2Table.getTable({ p2_table_keyno: keyno });
    }
}
